<div
  class="container"
  [class.larger]="showConfirmation">
  <div class="content">
    <div class="dialog-headline">
      <h3>Reject Queued Elements</h3>
    </div>
    @if (loadingPopupData) {
      <div class="loading-spinner">
        <app-turbine [contrast]="true"></app-turbine>
      </div>
    }
    @if (!loadingPopupData) {
      <div class="box">
        @if (logsAheadInQueue.length) {
          <div class="group">
            <p>
              There are currently the following
              {{ logsAheadInQueue.length }} uploads ahead in Queue:
            </p>
            <ul>
              @for (log of logsAheadInQueue; track log) {
                <li>
                  <p>
                    {{ log.uploadedAt | date: 'MMM d, y' }}:
                    {{ log.fileName | fileName }}
                    ({{ log.state | uppercase }})
                  </p>
                </li>
              }
            </ul>
            <p>Do you want to skip these uploads? This will automatically reject the listed uploads.</p>
          </div>
        } @else {
          <div class="group">
            <p></p>
            <p>This element is already on the top position of the queue.</p>
            <p>Cannot remove any previous pending uploads.</p>
          </div>
        }
        <div class="buttons">
          <coin-v2-button
            [type]="'secondary'"
            [icon]="'close'"
            [iconPos]="'right'"
            [text]="'Cancel'"
            [disabled]="showConfirmation"
            (click)="close()"></coin-v2-button>

          <coin-v2-button
            [type]="'primary'"
            [icon]="'chevron_right'"
            [iconPos]="'right'"
            [text]="'Begin staging of current log'"
            [disabled]="showConfirmation || !currentLog || !logsAheadInQueue.length"
            (click)="showConfirmation = true"></coin-v2-button>
        </div>
        @if (showConfirmation) {
          <div class="box">
            <div class="group">
              <p>
                <strong>This will reject {{ logsAheadInQueue.length }} previous uploads. Are you sure?</strong>
              </p>
            </div>
            <div class="buttons">
              <coin-v2-button
                [type]="'secondary'"
                [icon]="'close'"
                [iconPos]="'right'"
                [text]="'Cancel'"
                (click)="close()"></coin-v2-button>

              <coin-v2-button
                [type]="'primary'"
                [icon]="'chevron_right'"
                [iconPos]="'right'"
                [text]="'Yes - Reject previous uploads'"
                [disabled]="loadingPopupData"
                (click)="submit()"></coin-v2-button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
